import { ReactElement } from 'react';
import { Box, Paper, Stack, SvgIcon, Typography } from '@mui/material';
import { AppCheckBox } from 'shared/components/AppComponents';

import { ReactComponent as Link } from 'assets/images/ic_link.svg';
import { ReactComponent as Document } from 'assets/images/ic_document.svg';
import { useFormikContext } from 'formik';

const PolicyModeCard = (): ReactElement => {
  const { values, setFieldValue }: any = useFormikContext();

  return (
    <Paper variant="outlined">
      <Typography variant="h6">Policy Mode</Typography>
      <Typography className="mt-2">
        Choose how you want to provide the policy content
      </Typography>
      <Stack direction="column" spacing={2}>
        <Typography variant="body2">Policy Mode</Typography>
        <Stack direction="row" spacing={2}>
          <AppCheckBox
            checked={values?.policyMode === 'Url'}
            onChange={() => {
              setFieldValue('policyMode', 'Url', true);
            }}
            name="urlmode"
          />
          <SvgIcon
            component={Link}
            inheritViewBox
            className="view-icon"
            fontSize="inherit"
            htmlColor="#D1F27A"
          />
          <Box className="url-mode-policy">
            <Typography variant="subtitle2">URL Mode</Typography>
            <Typography component="span">
              Link to an existing policy document
            </Typography>
          </Box>
        </Stack>
        <Stack direction="row" spacing={2}>
          <AppCheckBox
            checked={values?.policyMode === 'Content'}
            onChange={() => {
              setFieldValue('policyMode', 'Content', true);
            }}
            name="buildpolicy"
          />
          <SvgIcon
            component={Document}
            inheritViewBox
            className="view-icon"
            fontSize="inherit"
            htmlColor="#D1F27A"
          />
          <Box className="url-mode-policy">
            <Typography variant="subtitle2">Build Your Policy</Typography>
            <Typography component="span">
              Create policy content using our rich text editor
            </Typography>
          </Box>
        </Stack>
      </Stack>
    </Paper>
  );
};

export default PolicyModeCard;
